module.exports = __webpack_public_path__ + "media/application/images/2023/05_still-1450x816-babe582f82920f83e919684a785c2fad.png";